import React from "react";

export default function ProgramacionModal({
  tipoNuevo,
  onTipoChange,
  nuevoProg,
  onChangeField,
  touched,
  errors,
  sectores,
  sectoresSeleccionados,
  onToggleSector,
  handleDuracionSectorChange,
  duracionComun,
  onDuracionComunChange,
  onSave,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
      <div className="bg-[#0e3b63] text-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto p-8 grid grid-cols-1 md:grid-cols-2 gap-8 shadow-lg">
        <section>
          <header className="mb-6 flex justify-between items-center">
            <h2 className="text-2xl font-bold">
              {nuevoProg.programacionId ? "Editar Programación" : "Nueva Programación"}
            </h2>
            <button
              onClick={onClose}
              className="text-white text-3xl font-bold leading-none hover:text-gray-300"
              aria-label="Cerrar modal"
            >
              ×
            </button>
          </header>

          {/* Tipo de programación */}
          <div className="mb-6">
            <label className="block mb-2 font-semibold">Tipo de programación</label>
            <select
              className="w-full p-2 rounded bg-[#164070] text-white"
              value={tipoNuevo}
              onChange={(e) => onTipoChange(e.target.value)}
            >
              <option value="semanal">Semanal</option>
              <option value="diaria">Diaria</option>
            </select>
          </div>

          {/* Campos según tipo */}
          {tipoNuevo === "semanal" ? (
            <>
              <div className="mb-4">
                <label className="block mb-2">Hora inicio</label>
                <input
                  type="time"
                  className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                    touched.startTime && errors.startTime
                      ? "border-red-500 bg-red-950"
                      : "border-transparent"
                  }`}
                  value={nuevoProg.startTime}
                  onChange={(e) => onChangeField("startTime", e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Ciclos por día</label>
                <input
                  type="number"
                  min={1}
                  className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                    touched.cyclesPerDay && errors.cyclesPerDay
                      ? "border-red-500 bg-red-950"
                      : "border-transparent"
                  }`}
                  value={nuevoProg.cyclesPerDay}
                  onChange={(e) => onChangeField("cyclesPerDay", e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Intervalo entre ciclos</label>
                <input
                  type="time"
                  className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                    touched.intervalTime && errors.intervalTime
                      ? "border-red-500 bg-red-950"
                      : "border-transparent"
                  }`}
                  value={nuevoProg.intervalTime}
                  onChange={(e) => onChangeField("intervalTime", e.target.value)}
                />
              </div>
              <div className="mb-6">
                <label className="block mb-2">Días de la semana</label>
                <div className="flex flex-wrap gap-2">
                  {[1, 2, 3, 4, 5, 6, 7].map((dia) => (
                    <button
                      key={dia}
                      type="button"
                      onClick={() => onChangeField("toggleDay", dia)}
                      className={`px-3 py-1 rounded-full border ${
                        nuevoProg.days.includes(dia)
                          ? "bg-green-600 border-green-600"
                          : "border-gray-400"
                      } ${
                        touched.days && errors.days ? "ring-2 ring-red-500" : ""
                      }`}
                    >
                      { ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"][dia-1] }
                    </button>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="mb-4">
                <label className="block mb-2">Fecha inicio</label>
                <input
                  type="date"
                  className="w-full p-2 rounded bg-[#164070] text-white"
                  value={nuevoProg.startDate}
                  onChange={(e) => onChangeField("startDate", e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Hora inicio</label>
                <input
                  type="time"
                  className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                    touched.cyclicStartTime && errors.cyclicStartTime
                      ? "border-red-500 bg-red-950"
                      : "border-transparent"
                  }`}
                  value={nuevoProg.cyclicStartTime}
                  onChange={(e) => onChangeField("cyclicStartTime", e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Intervalo (días)</label>
                <input
                  type="number"
                  min={1}
                  className="w-full p-2 rounded bg-[#164070] text-white"
                  value={nuevoProg.daysInterval}
                  onChange={(e) => onChangeField("daysInterval", e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Ciclos por día</label>
                <input
                  type="number"
                  min={1}
                  className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                    touched.cyclicCyclesPerDay && errors.cyclicCyclesPerDay
                      ? "border-red-500 bg-red-950"
                      : "border-transparent"
                  }`}
                  value={nuevoProg.cyclicCyclesPerDay}
                  onChange={(e) => onChangeField("cyclicCyclesPerDay", e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block mb-2">Intervalo entre ciclos</label>
                <input
                  type="time"
                  className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                    touched.cyclicIntervalTime && errors.cyclicIntervalTime
                      ? "border-red-500 bg-red-950"
                      : "border-transparent"
                  }`}
                  value={nuevoProg.cyclicIntervalTime}
                  onChange={(e) => onChangeField("cyclicIntervalTime", e.target.value)}
                />
              </div>
            </>
          )}

          {/* Duración común global */}
          <div className="mb-6">
            <label className="block mb-2 font-semibold">
              Duración común para todas las válvulas (opcional)
            </label>
            <input
              type="text"
              placeholder="Ej: 00:02 (mm:ss)"
              className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                touched.duracionComun && errors.duracionComun
                  ? "border-red-500 bg-red-950"
                  : "border-transparent"
              }`}
              value={duracionComun}
              onChange={(e) => onDuracionComunChange(e.target.value)}
            />
            {touched.duracionComun && errors.duracionComun && (
              <small className="text-red-400">Formato inválido, debe ser mm:ss</small>
            )}
            <small className="text-gray-300 block mt-1">
              Si rellenas este campo (mm:ss), la duración se aplicará a todas las válvulas.
            </small>
          </div>

          {/* Botones */}
          <div className="flex gap-2">
            <button
              onClick={onSave}
              className="bg-green-600 hover:bg-green-700 w-full py-3 rounded-full font-bold text-lg transition"
            >
              Guardar Programación
            </button>
            <button
              onClick={onClose}
              className="bg-gray-500 hover:bg-gray-600 w-full py-3 rounded-full font-bold text-lg transition"
              type="button"
            >
              Cancelar
            </button>
          </div>
        </section>

        {/* Selección de sectores */}
        <section className="overflow-y-auto max-h-[70vh]">
          <h3 className="text-xl font-semibold mb-4">Sectores disponibles</h3>
          <ul className="space-y-3 mb-6">
            {sectores.length === 0 ? (
              <li className="text-gray-400 italic">No hay sectores disponibles</li>
            ) : (
              sectores.map((sec) => (
                <li
                  key={sec.sectorId}
                  onClick={() => onToggleSector(sec)}
                  className={`cursor-pointer rounded-lg p-3 border transition
                    ${
                      sectoresSeleccionados.some((s) => s.sectorId === sec.sectorId)
                        ? "bg-green-700 border-green-500"
                        : "bg-[#164070] border-transparent hover:border-green-400"
                    }
                  `}
                >
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-green-200">{sec.sectorNombre}</span>
                    <span className="text-sm text-green-300">
                      {sec.valvulas.length} válvulas
                    </span>
                  </div>
                </li>
              ))
            )}
          </ul>

          <h3 className="text-xl font-semibold mb-3">Sectores seleccionados</h3>
          {sectoresSeleccionados.length === 0 ? (
            <p className="italic text-gray-400 mb-3">No has seleccionado sectores aún.</p>
          ) : (
            <ul className="space-y-4 max-h-[35vh] overflow-y-auto">
              {sectoresSeleccionados.map((sec) => (
                <li key={sec.sectorId} className="border border-green-500 rounded-lg p-3 bg-green-900/70">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-lg text-green-400 font-bold">{sec.sectorNombre}</span>
                    <button
                      onClick={() => onToggleSector(sec)}
                      title="Quitar sector"
                      className="text-red-400 hover:text-red-600 font-bold"
                    >
                      ×
                    </button>
                  </div>
                  <label className="block text-sm mb-1">
                    Duración para este sector (mm:ss)
                  </label>
                  <input
                    type="text"
                    placeholder="Ej: 00:02"
                    value={sec.duracionComunSector}
                    onChange={(e) => handleDuracionSectorChange(sec.sectorId, e.target.value)}
                    className={`w-full p-2 rounded bg-[#164070] text-white border-2 ${
                      touched[`sector_${sec.sectorId}`] && errors[`sector_${sec.sectorId}`]
                        ? "border-red-500 bg-red-950"
                        : "border-transparent"
                    }`}
                  />
                  {touched[`sector_${sec.sectorId}`] && errors[`sector_${sec.sectorId}`] && (
                    <small className="text-red-400">Formato inválido, debe ser mm:ss</small>
                  )}
                  <small className="text-gray-400 block mt-1">
                    Si no se rellena, se usa la duración global o por válvula.
                  </small>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
}
